<template>
    <div class="wrapper">
        <div class="columns">
            <div class="column">
                <span @click="$router.go(-1)" class="btn btn-clear">Back</span>

            </div>

        </div>
        <div class="columns is-justify-content-center">
            <div class="column is-6-tablet is-4-desktop">
                <ul class="steps">
                    <li class="active"><span>1</span></li>
                    <li><span>2</span></li>
                    <li><span>3</span></li>
                </ul>
            </div>
        </div>
        <div class="columns is-flex-wrap-wrap is-align-items-center is-justify-content-center">
            <div class="column is-6-tablet">

            <h1 class="is-size-4 has-text-weight-bold m-b-40 m-b-20-mobile">Create an account</h1>



                <b-message v-if="message==true" type="is-success" aria-close-label="Close message">
                    <p>We have emailed {{nameShown}}.</p>
                    <p>On the email, click on the <strong>Sign Up</strong> button and you're all set!</p>
                    <hr>
                    <p><small>You should receive our email shortly. If not:</small></p>
                    <ul>
                        <li><small>Check your email address above is correct. If not, please <a href="/register">amend</a> it</small></li>
                        <li><small>Please check your Junk email folder</small></li>
                        <li><small>Please <a href="/contact">contact us</a> or email <a
                            href="mailto:support@pickafund.com" target="_blank">support@pickafund.com</a></small></li>
                    </ul>
                </b-message>

                <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">



                    <b-message v-if="invalid && validated "  type="is-danger" aria-close-label="Close message">
                    This form contains errors
                    </b-message>


                    <div class="columns is-vcentered is-desktop m-b-0-mobile">
                        <div class="column is-12 is-12-mobile">
                            <ValidationProvider rules="required|email|min:8" v-slot="{ errors,valid }">
                                <b-field
                                    :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                    :message="errors"
                                >

                                    <b-input placeholder="Email"
                                            size="is-medium"
                                            v-model="form.name"
                                            icon="account"
                                            type="email"
                                            novalidate
                                            autocapitalize="off">
                                    </b-input>
                                </b-field>
                            </ValidationProvider>
                        </div>
                    </div>
                    <div class="columns is-vcentered is-desktop m-b-0-mobile">
                        <div class="column is-12 is-12-mobile">
                            <ValidationProvider name="password" rules="required|min:8" v-slot="{ errors,valid }">
                                <b-field
                                    :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                    :message="errors"
                                >
                                    <b-input placeholder="Password"
                                            v-model="form.password"
                                            type="password"
                                            size="is-medium"
                                            icon="account"
                                            password-reveal>
                                    </b-input>
                                </b-field>
                            </ValidationProvider>
                        </div>
                    </div>
                    <div class="columns is-vcentered is-desktop m-b-0-mobile">
                        <div class="column is-12 is-12-mobile">
                            <ValidationProvider name="confirm" rules="required|password:@password" v-slot="{ errors,valid }">
                                <b-field
                                    :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                    :message="errors"
                                >
                                    <b-input placeholder="Repeat Password"
                                            type="password"
                                            size="is-medium"
                                            icon="account"
                                            v-model="form.passwordConfirm"
                                            password-reveal
                                    >
                                    </b-input>
                                </b-field>
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="columns is-vcentered is-desktop m-b-0-mobile">
                        <div class="column is-12 is-12-mobile">
                            <ValidationProvider rules="isLegal" v-slot="{ errors,valid }">
                                <b-field
                                    :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                    :message="errors"
                                >
                                <div class="field">
                                    <div class="is-flex is-align-items-center">
                                        <b-switch
                                            v-model="privacypolicy">
                                        </b-switch>
                                        I accept the&nbsp;<a @click="$router.push('/privacy')">Privacy Policy</a>
                                    </div>
                                </div>
                            </b-field>
                            </ValidationProvider>
                        </div>
                    </div>
                    <div class="columns p-t-30 has-text-centered p-b-40 p-t-20-mobile p-b-20-mobile">
                        <div class="column is-12 is-12-desktop is-centered">
                            <b-button v-if="submitted===false" @click="submit" type="is-primary">NEXT</b-button>
                            <router-link v-else class="button is-primary"  to="/login" type="is-primary">BACK</router-link>

                        </div>
                    </div>
                </ValidationObserver>

            </div>
        </div>
    </div>
</template>

<style scoped>

</style>

<script>


import {ValidationProvider, ValidationObserver, setInteractionMode} from 'vee-validate';
import axios from "axios";

setInteractionMode('eager')

export default {
    name: 'SignUp1',
    components: {
        ValidationProvider,
        ValidationObserver
    },
    props: {},
    data() {
        return {
            nameShown:"",
            message: false,
            privacypolicy:false,
            form: {
                name: "",
                //email:"xxx@temp.com",
                password: "",
                passwordConfirm: "",
            },
            submitted:false
        }
    },
    methods: {
        async submit() {

            this.$refs.observer.validate().then(async success => {
                if (!success) {
                    const el = document.querySelector(".help.is-danger:first-of-type");
                    el.scrollIntoView(true);
                    window.scrollBy(0, -150);
                    return;
                }

                await axios.get('/sanctum/csrf-cookie');

                await axios.post("/api/register", this.form)
                    .then(response => {
                        if (response.data.success === true) {
                            this.message = true
                            this.nameShown=this.form.name
                            this.form.name = ""
                            this.form.password = ""
                            this.form.passwordConfirm = ""
                            this.submitted=true
                            this.$refs.observer.reset()
                        } else {
                            this.$toast.error(response.data.errors[0])
                           
                        }
                    })
                    .catch(error => {
                        if(error.response.status === 423){
                            this.$toast.error("This account has not been activated via email yet")
                        }
                        else{
                            this.$toast.error("We could not register your account. Please try again later")
                        }
                        }
                    )

            })
        }
    },
}

</script>


